import React, { useMemo, useCallback, useEffect } from 'react'
import { Form, Space } from 'antd'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import { SpaceWrapper } from './styles'
import { getInputNode } from 'src/react-app/components/json-form-object-editor'

const ArrayMultiFild = ({
  value,
  onChange,
  schema,
  UISchema,
}: {
  value?: any
  onChange?: any
  schema: any
  UISchema: any
}) => {
  const [form] = Form.useForm()
  const items = useMemo(() => {
    if (Array.isArray(value)) {
      return value
    }
    if (schema?.items?.type === 'object') {
      return [{}]
    }
    return [undefined]
  }, [value, schema])

  // Синхронизируем форму при изменении value (initialValues применяются только при монтировании)
  useEffect(() => {
    form.setFieldsValue({ items })
  }, [form, items])

  const localOnChange = useCallback(
    (_: any, allValues: { items?: any[] }) => {
      if (allValues?.items !== undefined && onChange) {
        onChange(allValues.items)
      }
    },
    [onChange],
  )

  const InputNode = useMemo(() => {
    const schemaItems = schema['items']
    return getInputNode(schemaItems)
  }, [schema])

  return (
    <Form
      form={form}
      name="array"
      layout="vertical"
      onValuesChange={localOnChange}
      autoComplete="off"
      initialValues={{ items }}
    >
      <Form.List name="items">
        {(fields, { add, remove }) => (
          <Space direction="vertical" style={{ width: '100%' }}>
            {fields.map(field => (
              <SpaceWrapper key={field.key}>
                <Form.Item name={field.name} style={{ flex: 1, marginBottom: 0 }}>
                  {InputNode}
                </Form.Item>
                <PlusOutlined
                  style={{ padding: 5, fontSize: 20, cursor: 'pointer' }}
                  onClick={() => add(schema?.items?.type === 'string' ? '' : undefined)}
                />
                <MinusCircleOutlined
                  style={{ padding: 5, fontSize: 20, cursor: 'pointer' }}
                  onClick={() => remove(field.name)}
                />
              </SpaceWrapper>
            ))}
          </Space>
        )}
      </Form.List>
    </Form>
  )
}

export default ArrayMultiFild
